module.exports = __webpack_public_path__ + "static/media/work-accent.2fcc852c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/work-accent.svg
// module id = 197
// module chunks = 0